import svgPanZoom from "svg-pan-zoom";
import Hammer from "hammerjs";

export const svgMixin = {
    data() {
        return {
            svgPanZoomOptions: {
                zoomScaleSensitivity: 0.5,
                // viewportSelector: '.svg-pan-zoom_viewport',
                minZoom: 1,
                maxZoom: 6,
                fit: true,
                center: true,
                dblClickZoomEnabled: false,
                // refreshRate: 10
                beforePan: this.beforePan,
                customEventsHandler: {
                    // Halt all touch events
                    haltEventListeners: ['touchstart', 'touchend', 'touchmove', 'touchleave', 'touchcancel'],
                    init: ((options) => {
                        let instance = options.instance,
                            initialScale = 1,
                            pannedX = 0,
                            pannedY = 0

                        // Init Hammer
                        this.hammer = Hammer(options.svgElement)

                        // Listen only for pointer and touch events
                        // this.hammer = Hammer(options.svgElement, {
                        //     inputClass: Hammer.SUPPORT_POINTER_EVENTS ? Hammer.PointerEventInput : Hammer.TouchInput
                        // })


                        // Handle pan
                        this.hammer.on('panstart panmove', function (ev) {
                            // On pan start reset panned variables
                            if (ev.type === 'panstart') {
                                pannedX = 0
                                pannedY = 0
                            }

                            // Pan only the difference
                            instance.panBy({x: ev.deltaX - pannedX, y: ev.deltaY - pannedY})
                            pannedX = ev.deltaX
                            pannedY = ev.deltaY
                        })

                        this.hammer.get('pinch').set({enable: true})
                        // Handle pinch
                        this.hammer.on('pinchstart pinchmove', function(ev){
                            // On pinch start remember initial zoom
                            if (ev.type === 'pinchstart') {
                                initialScale = instance.getZoom()
                                instance.zoomAtPoint(initialScale * ev.scale, {x: ev.center.x, y: ev.center.y})
                            }

                            instance.zoomAtPoint(initialScale * ev.scale, {x: ev.center.x, y: ev.center.y})
                        })

                        // Handle tap
                        this.hammer.on('tap', ((ev) => {
                            if (ev.target.tagName === 'polygon') {
                                this.goToSection(ev.target.dataset.section);
                            }
                        }))


                        // Handle panstart
                        this.hammer.on('panstart', ((ev) => {
                            this.pan = true;
                            if (ev.target.tagName === 'polygon' && ev.target.nearestViewportElement.id === 'svg-scheme-list') {
                                this.sectionUnHover();
                            }
                        }))
                        // Handle panend
                        this.hammer.on('panend', (() => {
                            this.pan = false;
                        }))
                    }),
                    destroy: (() => {
                        this.hammer.destroy()
                    })
                }
            },
            svgPanZoomig: null,
            pan: false,
        }
    },
    methods: {
        async setHeaderSVG(id) {
            let promise = new Promise((resolve) => {
                // ВАЖНО! Необходимо программно задать конкретную высоту svg перед инициализацией svgPanZoom
                let hHeader = document.getElementById('w-header').clientHeight;
                let hFooter = document.getElementById('w-footer').clientHeight;
                let hTitleScene = document.getElementById('w-title-scene').clientHeight;
                let h_out_svg = hHeader + 33 + hTitleScene + 33 + hFooter + 32; // суммарная высота всех структурных элементов, кроме svg
                // document.getElementById(id).style.height = `calc(100vh - ${h_out_svg}px)`; // задаем высоту svg

                let intViewportHeight = window.innerHeight;
                document.getElementById(id).style.height = `calc(${intViewportHeight}px - ${h_out_svg}px)`;

                resolve(true)
            });

            let result = await promise;
            return result

        },
        initPanZoom(id) {
            /*
            * Init drag and zoom
            * */
            this.svgPanZoomig = svgPanZoom(`#${id}`, this.svgPanZoomOptions);

            this.svgPanZoomig.fit();
            this.svgPanZoomig.center();

            this.$nextTick(function () {
                setTimeout(() => this.$events.fire('hideLoader'), 500);
                // this.$events.fire('hideLoader');
            })
        },
        zoomPlus() {
            this.svgPanZoomig.zoomIn();
        },
        zoomMinus() {
            this.svgPanZoomig.zoomOut();
        },
        beforePan(oldPan, newPan) {
            let gutterWidth = 100,
                gutterHeight = 100,
                // Computed variables
                sizes = this.svgPanZoomig.getSizes(),
                leftLimit = -((sizes.viewBox.x + sizes.viewBox.width) * sizes.realZoom) + gutterWidth,
                rightLimit = sizes.width - gutterWidth - (sizes.viewBox.x * sizes.realZoom),
                topLimit = -((sizes.viewBox.y + sizes.viewBox.height) * sizes.realZoom) + gutterHeight,
                bottomLimit = sizes.height - gutterHeight - (sizes.viewBox.y * sizes.realZoom)

            let customPan = {}
            customPan.x = Math.max(leftLimit, Math.min(rightLimit, newPan.x))
            customPan.y = Math.max(topLimit, Math.min(bottomLimit, newPan.y))

            return customPan
        }
    },
    beforeDestroy() {
        if (this.svgPanZoomig) {
            this.svgPanZoomig.destroy();
            delete this.svgPanZoomig;
        }
    },
}
